import React, { createContext, useState, useEffect, useContext } from 'react';

var WebMonetizationContext = /*#__PURE__*/createContext(undefined);

var addMonetizationEventListener = function addMonetizationEventListener(event, eventListener) {
  var _document$monetizatio;

  (_document$monetizatio = document.monetization) == null ? void 0 : _document$monetizatio.addEventListener(event, eventListener, {
    passive: true
  });
  return function () {
    var _document$monetizatio2;

    return (_document$monetizatio2 = document.monetization) == null ? void 0 : _document$monetizatio2.removeEventListener(event, eventListener);
  };
};

var WebMonetizationProvider = function WebMonetizationProvider(_ref) {
  var children = _ref.children;

  var _useState = useState('pending'),
      state = _useState[0],
      setState = _useState[1];

  useEffect(function () {
    var onStart = function onStart() {
      setState('started');
    };

    var onStop = function onStop() {
      setState('stopped');
    };

    var events = [addMonetizationEventListener('monetizationstart', onStart), addMonetizationEventListener('monetizationprogress', onStart), addMonetizationEventListener('monetizationstop', onStop)];
    return function () {
      events.forEach(function (removeListener) {
        return removeListener();
      });
    };
  }, []);
  return React.createElement(WebMonetizationContext.Provider, {
    value: {
      isActive: state === 'started',
      state: state
    }
  }, children);
};

var useWebMonetization = function useWebMonetization() {
  var webMonetizationContext = useContext(WebMonetizationContext);

  if (!webMonetizationContext) {
    throw new Error("[useWebMonetization] You're using the context outside of the WebMonetizationProvider");
  }

  return webMonetizationContext;
};

export { WebMonetizationProvider, useWebMonetization };
//# sourceMappingURL=react-monetization.esm.js.map
